<section class="calendar-event-actions-dialog" aria-label="Event actions">
  <header class="calendar-event-actions-dialog__header">
    <div>
      <p class="calendar-event-actions-dialog__eyebrow">Calendar event</p>
      <h2>{{ data.event.title | titlecase}}</h2>
      <p class="calendar-event-actions-dialog__meta">{{ formatEventTime() }}</p>
    </div>

    <button type="button" mat-icon-button aria-label="Close event actions" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <div class="calendar-event-actions-dialog__list">
    @if (canJoin()) {
      <button type="button" class="calendar-event-actions-dialog__action" mat-stroked-button (click)="select('join')">
        <mat-icon aria-hidden="true">videocam</mat-icon>
        <span>Join Meeting</span>
      </button>
    }

    <button type="button" class="calendar-event-actions-dialog__action" mat-stroked-button (click)="select('edit')">
      <mat-icon aria-hidden="true">edit</mat-icon>
      <span>Edit Event</span>
    </button>

    <button type="button" class="calendar-event-actions-dialog__action" mat-stroked-button color="warn" (click)="select('delete')">
      <mat-icon aria-hidden="true">delete</mat-icon>
      <span>Delete Event</span>
    </button>
  </div>
</section>
